import React from "react"
import { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { Header } from "../../common/header/Header"
import { MenuClient } from "../MenuClient"
import { useNavigate, useParams } from "react-router-dom"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { ContractorClientAccount } from "./ContractorClientAccount"
import { IClientContractorDto } from "../../../types/contractor/IClientContractorDto"
import { CommonInput } from "../../common/element/fields/CommonInput"
import { CountryPicker } from "../../common/element/fields/CountryPicker"
import { ICountry } from "../../../types/dict/ICountry"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { IClientContractorAccountDto } from "../../../types/contractor/IClientContractorAccountDto"
import { ModalConfirm } from "../../common/element/ModalConfirm"
import { ContractorClientContract } from "./ContractorClientContract"
import { IClientContractorContract } from "../../../types/contractor/IClientContractorContract"
import { IValidatedRequestList } from "../../../types/IValidatedRequestList"

export const ContractorClient = () => {
  const params = useParams()
  const navigate = useNavigate()

  const [contractor, setContractor] = useState<IClientContractorDto>()
  const [accounts, setAccounts] = useState<IClientContractorAccountDto[]>([])
  const [contracts, setContracts] = useState<IClientContractorContract[]>([])
  const [errors, setErrors] = useState<IErrorModel>()
  const [sending, setSending] = useState(false)
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [modalConfirmRemove, setModalConfirmRemove] = useState<IModalMessage>()

  useEffect(() => {
    if (params.id && params.id !== "new") {
      TrinityAPI.getClientContractor(params.id, response => {
        if (response.status === 200) {
          setContractor(response.data)
          setAccounts(response.data.accounts || new Array([]))
          setContracts(response.data.contracts || [])
        } else {
          setModalMessage({
            title: "Ошибка!",
            text: "Ошибка получения компании: " + response.data.message
          })
        }
      })
    }
  }, [])

  const changeCountry = (countryList: ICountry[]) => {
    if (countryList.length === 0) {
      setContractor({ ...contractor, country: undefined })
    } else {
      setContractor({ ...contractor, country: countryList[0] })
    }
  }

  const submit = () => {
    if (sending) return
    setSending(true)
    if (contractor?.id) {
      TrinityAPI.updateClientContractor(contractor, response => {
        if (response.status === 200) {
          setContractor({ ...contractor, id: response.data.id })
          if (contractor.id && accounts.length > 0) {
            let req: IValidatedRequestList<IClientContractorAccountDto> = {
              requestBody: accounts
            }
            TrinityAPI.updateClientContractorAccounts(contractor.id, req, response => {
              if (response.status === 200) {
                setAccounts(response.data)
                setModalMessage({ title: "Инфо", text: "Компания сохранена" })
                setErrors(undefined)
                setSending(false)
              } else {
                setErrors(response.data)
                setSending(false)
              }
            })
          } else {
            setModalMessage({ title: "Инфо", text: "Компания сохранена" })
            setErrors(undefined)
            setSending(false)
          }
        } else {
          setErrors(response.data)
          setSending(false)
        }
      })
    } else {
      if (!contractor) {
        setModalMessage({ title: "Инфо", text: "Заполните обязательные поля" })
        setSending(false)
        return
      }
      TrinityAPI.createClientContractor(contractor, response => {
        if (response.status === 200) {
          setContractor({ ...contractor, id: response.data.id })
          setModalMessage({ title: "Инфо", text: "Компания создана" })
          setErrors(undefined)
        } else {
          setErrors(response.data)
        }
        setSending(false)
      })
    }
  }

  const remove = (confirm: boolean | undefined) => {
    if (contractor && contractor.id && confirm) {
      TrinityAPI.deleteClientContractor(contractor.id, response => {
        if (response.status === 200) {
          navigate(-1)
        } else {
          setModalMessage({
            ...modalMessage,
            title: "Ошибка!",
            text: `Ошибка удаления контрагента: ${response.data.message}`
          })
        }
      })
    }
  }

  const confirmRemove = () => {
    setModalConfirmRemove({
      ...modalConfirmRemove,
      title: "Удалить контрагента?",
      text: "Вы действительно желаете удалить контрагента?",
      _callback: remove,
      callbackValue: true
    })
  }

  return (
    <React.Fragment>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <ModalConfirm message={modalConfirmRemove} setMessage={() => setModalConfirmRemove(undefined)} />
      <MenuClient active={"contractor"} />
      <section className="new-contragent">
        <Header />
        <div className="container">
          <h3 className="ui-heading">{contractor?.id ? contractor.name : "Новый контрагент"}</h3>
          <div className="container-pop-up">
            <ul className="form-left">
              <li className="form-block-popup">
                <h4 className="heading-chapter">Информация</h4>
                <CommonInput
                  typeName={"text"}
                  label={"Полное название"}
                  placeholder={"Название компании"}
                  name={"name"}
                  value={contractor?.name}
                  errorModel={errors}
                  _callback={e => setContractor({ ...contractor, name: e })}
                />
                <CountryPicker
                  label={"Страна"}
                  value={contractor?.country ? new Array(contractor.country) : []}
                  size={1}
                  name={"country"}
                  errorModel={errors}
                  _callback={changeCountry}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Адрес"}
                  placeholder={"Адрес компании"}
                  name={"address"}
                  value={contractor?.address}
                  errorModel={errors}
                  _callback={e => setContractor({ ...contractor, address: e })}
                />
              </li>
              {contractor?.id ? (
                <>
                  <ContractorClientAccount accounts={accounts} setAccounts={setAccounts} errors={errors} />
                  <ContractorClientContract contracts={contracts} setContracts={setContracts} errors={errors} />
                </>
              ) : (
                <></>
              )}
            </ul>
            <div className="right-form">
              <div className="form-block-popup">
                <h4 className="heading-chapter">Контакты</h4>
                <CommonInput
                  typeName={"text"}
                  label={"ФИО"}
                  placeholder={"ФИО"}
                  name={"contactName"}
                  value={contractor?.contactName}
                  errorModel={errors}
                  _callback={e => setContractor({ ...contractor, contactName: e })}
                />
                {/*<CommonInput*/}
                {/*    typeName={"text"}*/}
                {/*    label={"Email"}*/}
                {/*    placeholder={"mail@mail.com"}*/}
                {/*    name={"contactEmail"}*/}
                {/*    value={contractor?.contactEmail}*/}
                {/*    errorModel={errors}*/}
                {/*    _callback={(e) => setContractor({...contractor, contactEmail: e})}/>*/}
                <CommonInput
                  typeName={"text"}
                  label={"Телефон"}
                  placeholder={"+7 200 000 00 00"}
                  name={"contactPhone"}
                  value={contractor?.contactPhone}
                  errorModel={errors}
                  _callback={e => setContractor({ ...contractor, contactPhone: e })}
                />
              </div>
            </div>
          </div>
          <div className="flex-row-10 flex-wrap">
            <button className="btn" onClick={submit}>
              {sending ? "Подождите..." : "Сохранить"}
            </button>
            <button className="btn grey-btn" onClick={() => navigate(-1)}>
              {contractor?.id ? "Назад" : "Отменить"}
            </button>
            {contractor?.id ? (
              <button className="btn black-btn" onClick={confirmRemove}>
                Удалить
              </button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}
